/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Rota {
  constructor () {
    this.rota_id = uuidV4()
    this.nome = ''
    this.rota_municipios = []
  }
}
